import { render, staticRenderFns } from "./Debate-hero.vue?vue&type=template&id=4e917280&scoped=true&"
import script from "./Debate-hero.vue?vue&type=script&lang=js&"
export * from "./Debate-hero.vue?vue&type=script&lang=js&"
import style0 from "./Debate-hero.vue?vue&type=style&index=0&id=4e917280&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e917280",
  null
  
)

export default component.exports